import React, { useEffect, useState } from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import { observer } from 'mobx-react';
import { Button } from 'react-bootstrap';
import { ICoupon } from '../../../../models/ICoupon';
import CreateCouponHOC from '../hoc/CreateCouponHOC';
import CreateCouponPopup from '../CreateCoupon/CreateCouponPopup';
import EditCouponHOC from '../hoc/EditCouponHOC';
import EditCouponPopup from '../EditCoupon/EditCouponPopup';
import { faPencil } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useStore } from '../../../../contexts/StoreProvider';
import DeletePopupHOC from '../../../agent-dashboard/hoc/DeletePopupHOC';
import DeletePopup from '../../../agent-dashboard/components/Delete/DeletePopup';
import toast from 'react-hot-toast';
import { formatMessage } from '../../../../translations/format-message';
import CustomPagination from '../../../../shared-components/Pagination/CustomPagination';
import { Box, CircularProgress } from '@mui/material';
const CouponList = (props: any) => {
    const [deleteEventId, setDeleteEventId] = useState<number>(-1);
    const [deleteEventName, setDeleteEventName] = useState<string>("");
    const { adminStore } = useStore();
    const {getAllCoupons, getAllCouponsState, allCoupons,addUpdateCouponState,setSelectedCouponUsingId,deleteCouponState,resetAddUpdateCoupon,resetDeleteCoupon,deleteCoupon, couponPaginationState, updateCouponPageNumber, updateCouponPageSize, resetCouponPagingState}  = adminStore;
    const [editCouponId, setEditCouponId] = useState();

    useEffect(() => {
        if(couponPaginationState.PagingDetails.isPagerChange){
            getAllCoupons(couponPaginationState.PagingDetails.PageNo,couponPaginationState.PagingDetails.PageSize);
            resetCouponPagingState();
        }
    }, [couponPaginationState.PagingDetails.isPagerChange]);


    useEffect(() => {
        if(addUpdateCouponState.success||deleteCouponState.success){
            getAllCoupons(couponPaginationState.PagingDetails.PageNo,couponPaginationState.PagingDetails.PageSize);
        }
    }, [addUpdateCouponState.success||deleteCouponState.success]);

    useEffect(() => {
        if (deleteCouponState.success ) {
            resetDeleteCoupon();
            getAllCoupons(couponPaginationState.PagingDetails.PageNo,couponPaginationState.PagingDetails.PageSize);
            props.deletePopupToggleHandler();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [deleteCouponState.success]);
    
    const onPageLimitChanged = (evt: any) => {
        updateCouponPageSize(parseInt(evt.target.value));
    };
    const onPageChanged = (pageNumber: number) => {
        updateCouponPageNumber(pageNumber);
    };
    const [disablePagination, setDisablePagination] = useState<boolean>(false);
    
    const handleCreateCouponModalClose = () => {
        props.createCouponPopupToggleHandler();
        resetAddUpdateCoupon();
    }

    const handleCreateCouponModalOpen = () => {
        props.createCouponPopupToggleHandler();
    }

    const handleEditCouponModalClose = () => {
        props.editCouponPopupToggleHandler();
        resetAddUpdateCoupon();
        resetDeleteCoupon();
    }

    const handleEditCoupon = (couponId: any) => {
        setEditCouponId(couponId);
        setSelectedCouponUsingId(couponId)
        props.editCouponPopupToggleHandler();
    }
    const handleDeleteClick = (couponId:number,couponName:string) => {
        setDeleteEventId(couponId);
        setDeleteEventName(couponName);
         props.deletePopupToggleHandler();
      };

      const deleteCouponHandler = (couponId: number)=>{
        deleteCoupon(couponId);
      }

    return (
        <>
            {props.showCreateCouponPopup && (
                <CreateCouponPopup modalClosed={handleCreateCouponModalClose} isLoading={addUpdateCouponState.inProgress}/>
            )}
            {props.showEditCouponPopup && (
                <EditCouponPopup modalClosed={handleEditCouponModalClose}  isLoading={addUpdateCouponState.inProgress}/>
            )}
            {props.showDeletePopup && (
                <DeletePopup modalClosed={props.deletePopupToggleHandler} isLoading={deleteCouponState.inProgress} Id={deleteEventId} Title={deleteEventName}  deleteHandler={deleteCouponHandler}/>
            )}

            {
                !(getAllCouponsState.inProgress || (!getAllCouponsState.success && getAllCouponsState.error === '' )) &&
                <div className="dashboardTopbar">
                    <div className="container">
                        <div className="row align-items-center">
                            <div className="col-7">
                                <p className="text-dark"><FormattedMessage id="coupon_total" />&nbsp;{couponPaginationState.PagingDetails.TotalRecords}</p>
                            </div>
                            <div className="col-5 text-end">
                            <button className='btn btn-primary text-white'
                                onClick={handleCreateCouponModalOpen}><i className="fa fa-plus"></i> <FormattedMessage id="coupon_create_new_event"></FormattedMessage></button>
                            </div>
                        </div>
                    </div>
                </div>
            }
        
            <div className='container'>
                {
                    getAllCouponsState.inProgress || (!getAllCouponsState.success && getAllCouponsState.error === '' ) 
                    ?
                    <>
                        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '150px'}}>
                            <CircularProgress disableShrink={true}/>
                        </Box>
                    </>
                    :
                allCoupons.length > 0 ? (
                    <div className=''>
                        
                        <div className='table-responsive'>
                            <table className="table tableDesign">
                                <thead>
                                    <tr>
                                        <th style={{width: "400px"}}><FormattedMessage id="coupon_name" /></th>
                                        <th><FormattedMessage id="coupon_code" /></th>
                                        <th><FormattedMessage id="coupon_discount" /></th>
                                        <th><FormattedMessage id="coupon_on/off" /></th>
                                        <th style={{width: "100px"}}><FormattedMessage id="actions" /></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        allCoupons.map((item: ICoupon, index) => {
                                            return <>
                                                <tr key={index} className='col-12'>
                                                    <td>{item.couponName}</td>
                                                    <td>{item.couponCode}</td>
                                                    <td>{item.discount}</td>
                                                    <td>    {
                                                        item.status === "ON" ? <span className='badge bg-success'>{item.status}</span> :
                                                            <span className='badge bg-danger'>{item.status}</span>
                                                    }</td>
                                                    <td className='d-flex justify-content-end'> 
                                                        <button className='btn btn-outline-info me-2 btn-sm'  onClick={() => handleEditCoupon(item.id)} title={formatMessage('edit')}>
                                                            <svg height="492pt" viewBox="0 0 492.49284 492" width="492pt" xmlns="http://www.w3.org/2000/svg"><path d="m304.140625 82.472656-270.976563 270.996094c-1.363281 1.367188-2.347656 3.09375-2.816406 4.949219l-30.035156 120.554687c-.898438 3.628906.167969 7.488282 2.816406 10.136719 2.003906 2.003906 4.734375 3.113281 7.527344 3.113281.855469 0 1.730469-.105468 2.582031-.320312l120.554688-30.039063c1.878906-.46875 3.585937-1.449219 4.949219-2.8125l271-270.976562zm0 0" /><path d="m476.875 45.523438-30.164062-30.164063c-20.160157-20.160156-55.296876-20.140625-75.433594 0l-36.949219 36.949219 105.597656 105.597656 36.949219-36.949219c10.070312-10.066406 15.617188-23.464843 15.617188-37.714843s-5.546876-27.648438-15.617188-37.71875zm0 0" /></svg>
                                                        </button>
                                                        <button className='btn btn-sm btn-outline-danger me-auto' onClick={()=>handleDeleteClick(item.id,item.couponName)} title={formatMessage('delete')}>
                                                            <svg version="1.1" id="Layer_1" viewBox="0 0 512 512" >
                                                                <g>
                                                                    <g>
                                                                        <path d="M62.205,150l26.569,320.735C90.678,493.865,110.38,512,133.598,512h244.805c23.218,0,42.92-18.135,44.824-41.265
                L449.795,150H62.205z M180.986,452c-7.852,0-14.458-6.108-14.956-14.063l-15-242c-0.513-8.276,5.771-15.395,14.033-15.908
                c8.569-0.601,15.381,5.757,15.908,14.033l15,242C196.502,444.632,189.721,452,180.986,452z M271,437c0,8.291-6.709,15-15,15
                c-8.291,0-15-6.709-15-15V195c0-8.291,6.709-15,15-15s15,6.709,15,15V437z M360.97,195.938l-15,242
                c-0.493,7.874-7.056,14.436-15.908,14.033c-8.262-0.513-14.546-7.632-14.033-15.908l15-242
                c0.513-8.276,7.764-14.297,15.908-14.033C355.199,180.543,361.483,187.662,360.97,195.938z"/>
                                                                    </g>
                                                                </g>
                                                                <g>
                                                                    <g>
                                                                        <path d="M451,60h-90V45c0-24.814-20.186-45-45-45H196c-24.814,0-45,20.186-45,45v15H61c-16.569,0-30,13.431-30,30
                c0,16.567,13.431,30,30,30c137.966,0,252.039,0,390,0c16.569,0,30-13.433,30-30C481,73.431,467.569,60,451,60z M331,60H181V45
                c0-8.276,6.724-15,15-15h120c8.276,0,15,6.724,15,15V60z"/>
                                                                    </g>
                                                                </g>
                                                            </svg>
                                                        </button>
                                                    </td>
                                                </tr >
                                            </>
                                        })}
                                </tbody>
                            </table>
                        </div>
                    </div>
                ) : (
                    <div className="text-center">
                        <svg width="120px" height="120px" viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg"><g id="_x32_3_Error"><g><path d="m455.803 150.61v209.794c0 21.676-17.572 39.247-39.247 39.247h-321.113c-21.676 0-39.247-17.572-39.247-39.247v-209.794c0-21.676 17.572-39.247 39.247-39.247h321.113c21.676 0 39.247 17.572 39.247 39.247z" fill="#fefdfe"/><path d="m56.196 337.211v23.193c0 21.676 17.572 39.247 39.247 39.247h321.113c21.676 0 39.247-17.571 39.247-39.247v-23.193z" fill="#b8daff"/><path d="m287.344 399.651 29.049 59.341h-120.787l29.049-59.341z" fill="#fefdfe"/><path d="m350.768 479.252c0 11.189-9.071 20.26-20.26 20.26h-149.018c-11.189 0-20.26-9.071-20.26-20.26 0-11.189 9.071-20.26 20.26-20.26h149.018c11.19 0 20.26 9.07 20.26 20.26z" fill="#b8daff"/><path d="m149.218 232.364c10.044 0 215.265 0 213.562 0 15.702 0 25.426-17.103 17.394-30.596l-106.781-179.386c-7.848-13.184-26.939-13.184-34.787 0l-106.781 179.387c-8.032 13.492 1.691 30.595 17.393 30.595z" fill="#b8daff"/><path d="m269.999 90.064-2.319 51.008c-.284 6.245-5.43 11.162-11.681 11.162-6.252 0-11.397-4.917-11.681-11.162l-2.318-51.008c-.363-7.981 6.01-14.651 14-14.651 7.989.001 14.362 6.67 13.999 14.651z" fill="#fefdfe"/><circle cx="255.999" cy="189.093" fill="#fefdfe" r="14.666"/><g fill="#3f8cf4"><path d="m462.28 360.405c-.037-337.885-.016-144.267-.023-209.787 0-25.227-20.499-45.749-45.698-45.749h-60.047c-3.577 0-6.476 2.899-6.476 6.476s2.899 6.476 6.476 6.476h60.047c18.055 0 32.746 14.713 32.746 32.796v180.117h-386.61v-180.116c0-18.083 14.688-32.796 32.743-32.796h60.05c3.577 0 6.476-2.899 6.476-6.476s-2.899-6.476-6.476-6.476h-60.05c-25.197 0-45.696 20.522-45.696 45.749-.002 18.356.008-72.001-.023 209.787 0 25.016 20.351 45.744 45.719 45.744h118.827l-22.699 46.366h-10.076c-14.741 0-26.735 11.991-26.735 26.735s11.994 26.735 26.735 26.735h149.018c14.744 0 26.738-11.991 26.738-26.735s-11.994-26.735-26.738-26.735h-10.074l-22.699-46.366h118.824c25.03-.001 45.721-20.435 45.721-45.745zm-131.772 105.063c7.602 0 13.785 6.183 13.785 13.782 0 7.6-6.183 13.782-13.785 13.782h-149.018c-7.6 0-13.782-6.183-13.782-13.782 0-7.6 6.183-13.782 13.782-13.782zm-24.496-12.953h-100.024l22.698-46.366h54.628zm-210.569-59.339c-18.077 0-32.748-14.693-32.748-32.776v-16.712h386.61v16.712c0 18.039-14.744 32.776-32.748 32.776-219.076 0-166.7 0-321.114 0z"/><path d="m263.306 361.953h-14.615c-3.577 0-6.476 2.899-6.476 6.476s2.899 6.476 6.476 6.476h14.615c3.577 0 6.476-2.899 6.476-6.476s-2.899-6.476-6.476-6.476z"/><path d="m256.003 6.015c-.003 0-.003 0-.003 0-9.51 0-18.093 4.883-22.961 13.054l-106.78 179.383c-4.979 8.369-5.077 18.412-.268 26.877 4.812 8.46 13.497 13.514 23.229 13.514h213.571.013c9.722-.005 18.394-5.06 23.203-13.514 4.812-8.46 4.713-18.508-.266-26.877l-106.783-179.384c-4.865-8.171-13.446-13.048-22.955-13.053zm118.744 212.913c-2.479 4.361-6.952 6.962-11.966 6.962h-213.562c-5.014 0-9.489-2.606-11.969-6.962-2.479-4.361-2.426-9.537.139-13.848l106.782-179.383c2.507-4.215 6.929-6.729 11.829-6.729 4.9.005 9.322 2.515 11.827 6.729l106.783 179.383c2.565 4.311 2.616 9.487.137 13.848z"/><path d="m235.531 90.358 2.317 51.011c.445 9.72 8.417 17.339 18.151 17.339 9.737 0 17.709-7.62 18.149-17.344l2.32-51.006c.528-11.677-8.772-21.422-20.469-21.422s-21.002 9.739-20.468 21.422zm28-.587-2.32 51.006c-.126 2.793-2.416 4.979-5.211 4.979s-5.085-2.186-5.214-4.979l-2.317-51.006c-.194-4.302 3.232-7.883 7.531-7.883 4.276.001 7.726 3.554 7.531 7.883z"/><path d="m256 167.953c-11.657 0-21.142 9.482-21.142 21.139s9.484 21.144 21.142 21.144 21.142-9.487 21.142-21.144-9.485-21.139-21.142-21.139zm0 29.33c-4.516 0-8.189-3.673-8.189-8.192 0-4.513 3.673-8.186 8.189-8.186s8.189 3.673 8.189 8.186c0 4.519-3.673 8.192-8.189 8.192z"/></g></g></g><g id="Layer_1"/></svg>
                        <p className="noData text-muted text-center h4 mb-0">
                        <FormattedMessage id="no_data" />
                        </p>
                        <p className="mb-3">
                            <FormattedMessage id="no_coupon_collection" />
                        </p>
                    </div>
                )}
                { 
                <CustomPagination
                    onPageLimitChanged={onPageLimitChanged}
                    onPageChanged={onPageChanged}
                    pageSize={couponPaginationState.PagingDetails.PageSize}
                    totalPages={couponPaginationState.PagingDetails.TotalPages}
                    isRefreshPage={couponPaginationState.PagingDetails.isRefreshPage}
                    disablePagination={ allCoupons.length > 0 ? disablePagination : true }
                />
                }
            </div>
        </>
    )
}

export default EditCouponHOC(CreateCouponHOC(DeletePopupHOC(injectIntl(observer(CouponList)))));

